export default {
    address:'آدرس',
    province:'استان',
    city: 'شهر',
    country: 'کشور',
    postalCode: 'کد پستی', 
    home: 'منزل',
    work: 'محل کار',
    type: 'نوع'
}